/// Menu
//import Metismenu from "metismenujs";
import React, { useContext, useEffect, useReducer, useState } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import Collapse from 'react-bootstrap/Collapse';
/// Link
import { Link, useLocation} from "react-router-dom";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";


import { MenuSuperAdminList } from './MenuSuperAdmin';
import MyApiClient from "../../../api-client/MyApiClient";
import ManagerSubscriptionsApiClient from "../../../api-client/ManagerSubscriptionsApiClient";
import { BadgeCount } from './BadgeCount';
import SupportoNelMenu from './SupportoNelMenu';

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active : "",
  activeSubmenu : "",
}

const SideBar = () => {
	const {
		iconHover,
		sidebarposition,
		headerposition,
		sidebarLayout,
	} = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);
  const [badgeCount, setBadgeCount] = useState(0);
  const [billingBadgeCount, setBillingBadgeCount] = useState(0);
  const [managerSubsBadgeCount, setManagerSubsBadgeCount] = useState(0);
  const location = useLocation();
  const path = location.pathname;
  
  // For scroll
	const [hideOnScroll, setHideOnScroll] = useState(true)
	useScrollPosition(
		({ prevPos, currPos }) => {
		  const isShow = currPos.y > prevPos.y
		  if (isShow !== hideOnScroll) setHideOnScroll(isShow)
		},
		[hideOnScroll]
	)

  // I contatori (documenti da validare, richieste di fatturazione, abbonamenti) si rileggono a ogni cambio di pagina, ogni minuto e
  // quando si torna sulla scheda del browser: una richiesta nuova compare senza ricaricare. Ogni chiamata è indipendente,
  // così un errore su una non fa sparire i contatori delle altre.
  useEffect(() => {
    let annullato = false;
    const fetchBadgeCount = async () => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (!tokenDetailsString) return;
            const token = JSON.parse(tokenDetailsString).idToken;
            const apiClient = new MyApiClient();
            const managerSubsClient = new ManagerSubscriptionsApiClient();

            const [medicalCertificates, licenses, educations, billingRequests, managerSubs] = (await Promise.allSettled([
              apiClient.getMedicalCertificatesToApprove(token),
              apiClient.getLicensesToApprove(token),
              apiClient.getEducationsToApprove(token),
              apiClient.getClubInvoiceDataSenders(token),
              managerSubsClient.getAdminSubscriptions(token, {})
            ])).map(r => (r.status === 'fulfilled' ? r.value : null));
            if (annullato) return;

            const quanti = (v) => (Array.isArray(v) ? v.length : 0);
            setBadgeCount(quanti(medicalCertificates) + quanti(licenses) + quanti(educations));

            if (Array.isArray(billingRequests)) {
              const pendingBilling = billingRequests.filter(req =>
                req.invoiceDataSender && req.invoiceDataSender.status === 'WAIT_RESPONSE'
              );
              setBillingBadgeCount(pendingBilling.length);
            }

            if (Array.isArray(managerSubs)) {
              const toHandle = managerSubs.filter(s => s.invoiceStatus === 'NOT_SENT' || s.invoiceStatus === 'REJECTED');
              setManagerSubsBadgeCount(toHandle.length);
            }
        } catch (error) {
            console.error('Errore durante il recupero del badge count:', error);
        }
    };

    fetchBadgeCount();
    const timer = setInterval(fetchBadgeCount, 60 * 1000);
    const alRitorno = () => { if (document.visibilityState === 'visible') fetchBadgeCount(); };
    document.addEventListener('visibilitychange', alRitorno);
    return () => {
      annullato = true;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', alRitorno);
    };
  }, [path]);
  
  // Cambiata pagina, sul telefono il menu si richiude (come nella Struttura)
  useEffect(() => {
    const wrapper = document.getElementById('main-wrapper');
    if (window.innerWidth <= 767 && wrapper !== null) {
      wrapper.classList.remove('menu-toggle');
    }
  }, [path]);

  const handleMenuActive = status => {		
    setState({active : status});		
		if(state.active === status){			
      setState({active : ""});
    }
   
	}
	const handleSubmenuActive = (status) => {		
    setState({activeSubmenu : status})
		if(state.activeSubmenu === status){
      setState({activeSubmenu : ""})
			
		}
	}

  useEffect(() => {
    // Update active menu based on the current path
    const menuList = MenuSuperAdminList({ badgeCount, billingBadgeCount, managerSubsBadgeCount });
    // Si riparte da zero a ogni pagina: una voce non resta accesa su pagine che non sono sue (es. Account)
    if (!menuList.some(menu => (menu.content || []).some(sub => path.indexOf(sub.to) > -1) || (menu.to && (path.indexOf(menu.to) > -1 || (menu.attivoSu || []).some(p => path.indexOf(p) > -1))))) {
      setState({ active: '' });
    }
    
    menuList.forEach(menu => {
      // Submenu logic
      if (menu.content && menu.content.length > 0) {
        menu.content.forEach(submenu => {
           if(path.indexOf(submenu.to) > -1) {
             setState({ active: menu.title });
           }
        });
      } 
      // Top level link logic
      else if (menu.to) {
        if(path === menu.to || path.indexOf(menu.to) > -1 || (menu.attivoSu || []).some(p => path.indexOf(p) > -1)) {
          setState({ active: menu.title });
        }
      }
    });

  }, [path, badgeCount, billingBadgeCount, managerSubsBadgeCount]);

  return (
    <div
      className={`dlabnav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <PerfectScrollbar className="dlabnav-scroll d-flex flex-column justify-content-between">
             <ul className="metismenu" id="menu" style={{ overflow: 'hidden' }}>
                {MenuSuperAdminList({ badgeCount, billingBadgeCount, managerSubsBadgeCount }).map((data, index)=>{
                  let menuClass = data.classsChange;
                    if(menuClass === "menu-title"){
                      return(
                          <li className={menuClass}  key={index} >{data.title}</li>
                      )
                    }else{
                      return(				
                        <li className={` ${ state.active === data.title ? 'mm-active' : ''}`}
                          key={index} 
                        >
                          
                          {data.content && data.content.length > 0 ?
                              <Link to={"#"}
                                className="has-arrow"
                                onClick={() => {handleMenuActive(data.title)}}
                              >
                                  {data.iconStyle}
                                  <span className="nav-text">
                                      {data.title}
                                      <BadgeCount count={data.badge} />
                                  </span>
                              </Link>
                          :
                            <Link  to={data.to} >
                                {data.iconStyle}
                                <span className="nav-text">
                                    {data.title}
                                    <BadgeCount count={data.badge} />
                                </span>
                            </Link>
                          }
                          <Collapse in={state.active === data.title ? true :false}>
                            <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                              {data.content && data.content.map((data,index) => {									
                                return(	
                                    <li key={index}
                                      className={`${ state.activeSubmenu === data.title ? "mm-active" : ""}`}                                    
                                    >
                                      {data.content && data.content.length > 0 ?
                                          <>
                                            <Link to={data.to} className={data.hasMenu ? 'has-arrow' : ''}
                                              onClick={() => { handleSubmenuActive(data.title)}}
                                            >
                                              {data.title}
                                            </Link>
                                            <Collapse in={state.activeSubmenu === data.title ? true : false}>
                                                <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                                                  {data.content && data.content.map((data,index) => {
                                                    return(	
                                                      <>
                                                        <li key={index}>
                                                          <Link to={data.to} className={`${path === data.to ? "mm-active" : ""}`} >{data.title}</Link>
                                                        </li>
                                                      </>
                                                    )
                                                  })}
                                                </ul>
                                            </Collapse>
                                          </>
                                        :
                                        <Link to={data.hasMenu ? '#' : data.to}>
                                          {data.title}
                                          <BadgeCount count={data.badge} />
                                        </Link>
                                      }
                                      
                                    </li>
                                  
                                )
                              })}
                            </ul>
                          </Collapse>
                        </li>	
                      )
                  }
                })}          
            </ul>		  

            <SupportoNelMenu tipo="superadmin" />
        <div className="sid-powered-by">
              <div className="sid-powered-by__label">Powered by <strong>SportID</strong></div>
              <div className="sid-powered-by__version">Versione: {process.env.REACT_APP_VERSION}</div>
            </div>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
